import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Signal, Type } from '@angular/core';
import { OutOfStockComponent } from '@shared/components/challenges/elements';
import { CampaignPhase, SubType } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';
import {
  ExtendedFrequencyChallenge,
  FrequencyChallengeConfig,
} from '@shared/models';

import { Variant1Component } from './variant1/variant1.component';
import { Variant2Component } from './variant2/variant2.component';
import { Variant3Component } from './variant3/variant3.component';
import { Variant4Component } from './variant4/variant4.component';
import { Variant6Component } from './variant6/variant6.component';
import { Variant7Component } from './variant7/variant7.component';
import { Variant8Component } from './variant8/variant8.component';
import { Variant9Component } from './variant9/variant9.component';
import { Variant10Component } from './variant10/variant10.component';
import { Variant11Component } from './variant11/variant11.component';
import { Variant12Component } from './variant12/variant12.component';
import { FrequencyBaseClass } from './frequency.base.class';

@Component({
  selector: 'b2c-frequency-challenge',
  imports: [OutOfStockComponent, NgComponentOutlet],
  templateUrl: './frequency-challenge.component.html',
})
export class FrequencyChallengeComponent extends FrequencyBaseClass {
  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  challenge = input.required<FrequencyChallenge>();
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  /** Forwarded to the variant — see {@link Variant1Component.previewSelected}. */
  previewSelected = input<boolean>(false);

  config: Signal<FrequencyChallengeConfig> = computed(() => {
    const extendedConfig: ExtendedFrequencyChallenge =
      this.loyaltyChallengeConfig.components.challenges.frequency;
    return (
      extendedConfig[this.challenge().subType] ??
      extendedConfig[SubType.DEFAULT]
    );
  });

  public components = computed<
    Record<
      string,
      { inputs: Record<string, unknown>; component: Type<unknown> }
    >
  >(() => {
    const inputs = {
      phase: this.phase(),
      config: this.config(),
      challenge: this.challenge(),
      withShadow: this.withShadow(),
      isBisCampaign: this.isBisCampaign(),
      isEventChallenge: this.isEventChallenge(),
      // Only the variants the onboarding deck renders declare this input;
      // forwarding `false` to the others would log NG0303 on every page.
      ...(this.previewSelected() && { previewSelected: true }),
    };
    return {
      [this.Variants.VARIANT_1]: {
        inputs,
        component: Variant1Component,
      },
      [this.Variants.VARIANT_2]: {
        inputs,
        component: Variant2Component,
      },
      [this.Variants.VARIANT_3]: {
        inputs,
        component: Variant3Component,
      },
      [this.Variants.VARIANT_4]: {
        inputs,
        component: Variant4Component,
      },
      [this.Variants.VARIANT_6]: {
        inputs,
        component: Variant6Component,
      },
      [this.Variants.VARIANT_7]: {
        inputs,
        component: Variant7Component,
      },
      [this.Variants.VARIANT_8]: {
        inputs,
        component: Variant8Component,
      },
      [this.Variants.VARIANT_9]: {
        inputs,
        component: Variant9Component,
      },
      [this.Variants.VARIANT_10]: {
        inputs,
        component: Variant10Component,
      },
      [this.Variants.VARIANT_11]: {
        inputs,
        component: Variant11Component,
      },
      [this.Variants.VARIANT_12]: {
        inputs,
        component: Variant12Component,
      },
    };
  });
}
